// Full page loading spinner shown while the browser navigates to a new page.
// The loader is a DOM node we add to the body, so a browser that restores the
// page from its back/forward cache brings the spinner back with it. Removing it
// on pageshow clears the leftover spinner when the user hits "back".

const LOADER_CLASS = 'page-loader';

export function buildLoader() {
    const dataLoader = document.createElement('div');
    dataLoader.classList.add(LOADER_CLASS);
    dataLoader.classList.add('data-loader');
    dataLoader.classList.add('data-loader-fixed');
    const loaderHolder = document.createElement('div');
    const loader = document.createElement('div');
    loader.classList.add('loader');
    loaderHolder.classList.add('loader-holder');
    dataLoader.appendChild(loaderHolder);
    loaderHolder.appendChild(loader);
    document.querySelector('body').prepend(dataLoader);
}

export function removeLoaders() {
    document.querySelectorAll(`.${LOADER_CLASS}`).forEach(loader => loader.remove());
}

// True when the browser handed us a page we have already shown once.
// used to track when we need to manually clear out javascript binds
export function isRestoredNavigation(event: PageTransitionEvent) {
    if (event.persisted) {
        return true;
    }
    const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    return navigation?.type === 'back_forward';
}

window.addEventListener('pageshow', (e) => {
    if (isRestoredNavigation(e)) {
        removeLoaders();
    }
});
